/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Featured_2Inputs */

const en_featured_2 = /** @type {(inputs: Featured_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Featured`)
};

const es_featured_2 = /** @type {(inputs: Featured_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destacado`)
};

const fr_featured_2 = /** @type {(inputs: Featured_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En vedette`)
};

const de_featured_2 = /** @type {(inputs: Featured_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hervorgehoben`)
};

const ja_featured_2 = /** @type {(inputs: Featured_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`おすすめ`)
};

const zh_featured_2 = /** @type {(inputs: Featured_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推荐`)
};

const ar_featured_2 = /** @type {(inputs: Featured_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مميز`)
};

const id_featured_2 = /** @type {(inputs: Featured_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unggulan`)
};

const it_featured_2 = /** @type {(inputs: Featured_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Evidenza`)
};

const ru_featured_2 = /** @type {(inputs: Featured_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рекомендуемое`)
};

const pt_featured_2 = /** @type {(inputs: Featured_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destaque`)
};

const ko_featured_2 = /** @type {(inputs: Featured_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`추천`)
};

/**
* | output |
* | --- |
* | "Featured" |
*
* @param {Featured_2Inputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const featured_2 = /** @type {((inputs?: Featured_2Inputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Featured_2Inputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_featured_2(inputs)
	if (locale === "es") return es_featured_2(inputs)
	if (locale === "fr") return fr_featured_2(inputs)
	if (locale === "de") return de_featured_2(inputs)
	if (locale === "ja") return ja_featured_2(inputs)
	if (locale === "zh") return zh_featured_2(inputs)
	if (locale === "ar") return ar_featured_2(inputs)
	if (locale === "id") return id_featured_2(inputs)
	if (locale === "it") return it_featured_2(inputs)
	if (locale === "ru") return ru_featured_2(inputs)
	if (locale === "pt") return pt_featured_2(inputs)
	return ko_featured_2(inputs)
});